var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccPosCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pos_cash",
    "data-name": "Pos cash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8391",
    "data-name": "Rectangle 8391",
    width: 28,
    height: 28,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35889",
    "data-name": "Path 35889",
    d: "M6.754,5.28V8.488H23.418V17.4H26.54V5.28Z",
    fill: "#b3b5c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35245",
    "data-name": "Group 35245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35244",
    "data-name": "Group 35244",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35890",
    "data-name": "Path 35890",
    d: "M1.463,22.72H21.246V10.6H1.463Zm9.891-2.852a3.208,3.208,0,1,1,3.208-3.208,3.208,3.208,0,0,1-3.208,3.208",
    fill: "#b3b5c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccPosCash);
export default __webpack_public_path__ + "static/media/mcc_posCash.4ccea723f45bc5713ccc2b759e3faed4.svg";
export { ForwardRef as ReactComponent };